export class Rfs__all{

    static middlewareAuth(){}

    static header_Section(){};

    static profile_box(){};

    static header_auth(){};

    static menu_section(){};
    static menu_ui(){};

    static glob_provider(){};

    static btn_professorCard(arg:boolean){
        return arg
    };

}
